// Per-city SEO landing page data. Each entry produces /service-areas/{slug}.
// Copy is intentionally specific and unique per city to rank independently.

export const CITIES = [
  {
    slug: "york-pa",
    city: "York",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17401",
    lat: 39.9626,
    lng: -76.7277,
    tagline: "Termite Control in York, PA",
    hook: "From Avenues rowhomes to farmhouses off Route 30.",
    intro:
      "York homes run the gamut — century-old brick twins near Penn Park, mid-century ranches in Spring Garden, and new builds east toward Lincoln Highway. Subterranean termites quietly exploit the damp clay soil common across York County, tunneling up through foundations into sill plates and floor joists. ATC Pest Control has treated York homes for more than three decades.",
    local: [
      "Century-old brick twins and rowhomes (prime for hidden mud tubes)",
      "Clay-heavy soil holds moisture — ideal for subterranean colonies",
      "Close proximity to wooded state game lands increases swarming pressure",
    ],
    nearby: ["hanover-pa", "lancaster-pa", "gettysburg-pa"],
  },
  {
    slug: "hanover-pa",
    city: "Hanover",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17331",
    lat: 39.7998,
    lng: -76.983,
    tagline: "Termite Control in Hanover, PA",
    hook: "Serving homes from Broadway to Moul Avenue and beyond.",
    intro:
      "Hanover's mix of older downtown housing stock and newer developments toward South Hanover means termite pressure varies block by block. Older masonry foundations, crawlspaces, and wood-framed porches all offer easy entry for subterranean colonies. We've been Hanover's go-to termite company since 1991 — many of our customers here are second-generation.",
    local: [
      "Older downtown foundations with stone/mortar gaps",
      "Wood-framed porches and additions common in this area",
      "Higher-than-average swarmer activity reported April–June",
    ],
    nearby: ["york-pa", "gettysburg-pa", "westminster-md"],
  },
  {
    slug: "lancaster-pa",
    city: "Lancaster",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17602",
    lat: 40.0379,
    lng: -76.3055,
    tagline: "Termite Control in Lancaster, PA",
    hook: "Protecting historic Lancaster city homes and county farmhouses alike.",
    intro:
      "Lancaster's historic housing — some predating the Civil War — brings gorgeous architecture and equally serious termite vulnerability. Hand-hewn beams, original framing, and damp fieldstone basements are exactly what subterranean termites look for. Whether you're in Cabbage Hill, School Lane Hills, or out near Manheim Township, ATC knows how to treat old-home construction without damaging what makes it special.",
    local: [
      "Pre-1900 homes with original timber framing",
      "Fieldstone foundations with persistent moisture",
      "Heavy tree canopy = more shaded, termite-friendly soil",
    ],
    nearby: ["york-pa", "hershey-pa", "harrisburg-pa"],
  },
  {
    slug: "harrisburg-pa",
    city: "Harrisburg",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17101",
    lat: 40.2732,
    lng: -76.8867,
    tagline: "Termite Control in Harrisburg, PA",
    hook: "From Midtown brownstones to the suburbs of Paxtang and Susquehanna Twp.",
    intro:
      "Harrisburg's proximity to the Susquehanna River means higher soil moisture and stronger subterranean termite pressure than inland towns. Midtown and Shipoke rowhomes often share walls, so an untreated infestation can spread across units quickly. Our Inject-O-Matic perimeter treatment creates a continuous 360° barrier that handles party-wall and shared-foundation risks.",
    local: [
      "Susquehanna River proximity drives higher soil moisture",
      "Rowhome construction — shared walls mean shared risk",
      "Older city infrastructure with wood sill plates at grade level",
    ],
    nearby: ["mechanicsburg-pa", "carlisle-pa", "hershey-pa"],
  },
  {
    slug: "gettysburg-pa",
    city: "Gettysburg",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17325",
    lat: 39.8309,
    lng: -77.2311,
    tagline: "Termite Control in Gettysburg, PA",
    hook: "Protecting historic homes, farms, and additions around Adams County.",
    intro:
      "Gettysburg's historic homes and working farms create a perfect storm of termite risk: aged timber, earth-to-wood contact, and abundant woodpiles within swarming distance. We treat everything from Civil-War-era buildings to modern homes near the college — carefully, with respect for original materials.",
    local: [
      "Earth-to-wood contact common on historic homes and barns",
      "Abundant firewood and old outbuildings nearby",
      "Hand-hewn beams especially vulnerable to hidden damage",
    ],
    nearby: ["hanover-pa", "york-pa", "frederick-md"],
  },
  {
    slug: "hershey-pa",
    city: "Hershey",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17033",
    lat: 40.2859,
    lng: -76.6502,
    tagline: "Termite Control in Hershey, PA",
    hook: "From Derry Township ranches to new builds around Palmdale.",
    intro:
      "Hershey's wooded neighborhoods and well-landscaped yards feel idyllic — and termites agree. Dense mulch beds against foundations, wooden deck supports, and mature trees near homes all increase risk. We treat subterranean termite pressure in Hershey with Termidor, engineered for colony-level control.",
    local: [
      "Heavy mulch against foundation walls is a top risk factor",
      "Wooden deck support posts in direct soil contact",
      "Extensive tree canopy keeps soil cool and damp year-round",
    ],
    nearby: ["harrisburg-pa", "lancaster-pa", "mechanicsburg-pa"],
  },
  {
    slug: "carlisle-pa",
    city: "Carlisle",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17013",
    lat: 40.2014,
    lng: -77.1999,
    tagline: "Termite Control in Carlisle, PA",
    hook: "Serving historic Carlisle homes and newer Cumberland County developments.",
    intro:
      "Carlisle's blend of 18th-century limestone homes and modern suburban builds gives termites plenty of options. Older limestone foundations shift over decades, creating micro-gaps where mud tubes can travel undetected. ATC treats both styles with the same standard — thorough inspection, targeted treatment, renewable warranty.",
    local: [
      "Limestone foundations that shift and crack with age",
      "Basement storage often hides early termite activity",
      "Mix of historic and new construction in the same neighborhoods",
    ],
    nearby: ["mechanicsburg-pa", "harrisburg-pa", "gettysburg-pa"],
  },
  {
    slug: "mechanicsburg-pa",
    city: "Mechanicsburg",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17055",
    lat: 40.2117,
    lng: -77.0078,
    tagline: "Termite Control in Mechanicsburg, PA",
    hook: "Serving Upper Allen, Silver Spring Twp, and the 15/114 corridor.",
    intro:
      "Mechanicsburg has seen steady new construction — and new construction is when termite pre-treatment matters most. Builders often install thin treated-lumber sill plates that become vulnerable once the warranty expires. ATC offers both new-construction pre-treatments and retrofit Inject-O-Matic protection for existing homes.",
    local: [
      "Fast-growing newer developments and townhome communities",
      "Pre-treated lumber loses efficacy after ~5 years",
      "Increased swarmer activity reported in shared backyards",
    ],
    nearby: ["carlisle-pa", "harrisburg-pa", "hershey-pa"],
  },
  {
    slug: "baltimore-md",
    city: "Baltimore",
    state: "Maryland",
    stateCode: "MD",
    zip: "21201",
    lat: 39.2904,
    lng: -76.6122,
    tagline: "Termite Control in Baltimore, MD",
    hook: "From Federal Hill rowhomes to Roland Park bungalows.",
    intro:
      "Baltimore's iconic rowhomes create a distinct termite challenge: one infested unit can quietly spread through shared joists and sill plates to three or four neighbors before anyone notices. Older formstone, brick, and stone foundations all give termites access points. ATC's perimeter treatment and WDIR inspections are common requests before and after Baltimore settlements.",
    local: [
      "Rowhome construction — one infestation becomes many",
      "Formstone and brick foundations with interior access",
      "High demand for WDIR reports during Baltimore home sales",
    ],
    nearby: ["towson-md", "columbia-md", "annapolis-md"],
  },
  {
    slug: "towson-md",
    city: "Towson",
    state: "Maryland",
    stateCode: "MD",
    zip: "21204",
    lat: 39.4015,
    lng: -76.6019,
    tagline: "Termite Control in Towson, MD",
    hook: "Serving Rodgers Forge, Stoneleigh, and the heart of Baltimore County.",
    intro:
      "Towson's brick colonials and classic Baltimore County architecture sit on rich, forested lots that termites love. We routinely find active mud tubes at the rear of homes where patio slabs meet the foundation — one of the most common entry points in this area. Fast scheduling for Towson inspections.",
    local: [
      "Brick colonials with finished basements hiding early damage",
      "Patio slab / foundation seams are a classic entry point",
      "Dense, shaded landscaping around homes",
    ],
    nearby: ["baltimore-md", "westminster-md", "columbia-md"],
  },
  {
    slug: "frederick-md",
    city: "Frederick",
    state: "Maryland",
    stateCode: "MD",
    zip: "21701",
    lat: 39.4143,
    lng: -77.4105,
    tagline: "Termite Control in Frederick, MD",
    hook: "Historic downtown homes, farms, and newer Ballenger Creek builds.",
    intro:
      "Frederick's historic downtown is full of two- and three-hundred-year-old homes with hand-framed timber that's exactly what subterranean termites are hunting for. Out toward Ballenger Creek and Urbana, the fast new-construction growth brings its own termite risks as pre-treatments age out. ATC covers both.",
    local: [
      "Centuries-old downtown framing with hand-hewn beams",
      "Rapid new development expiring out of builder pre-treatment",
      "Monocacy River basin adds regional soil moisture",
    ],
    nearby: ["westminster-md", "rockville-md", "gettysburg-pa"],
  },
  {
    slug: "westminster-md",
    city: "Westminster",
    state: "Maryland",
    stateCode: "MD",
    zip: "21157",
    lat: 39.5754,
    lng: -76.9958,
    tagline: "Termite Control in Westminster, MD",
    hook: "From downtown Main Street homes to Carroll County farms.",
    intro:
      "Westminster's mix of working farms and downtown historic homes makes it a high-activity termite zone. Outbuildings, wood piles, and earth-to-wood contact on older barns all contribute to pressure on primary homes. We treat the home and help you understand the risk factors on surrounding property.",
    local: [
      "Active farmsteads and outbuildings increase swarming",
      "Historic downtown homes with original framing",
      "Common Carroll County clay soil holds moisture well",
    ],
    nearby: ["frederick-md", "towson-md", "hanover-pa"],
  },
  {
    slug: "columbia-md",
    city: "Columbia",
    state: "Maryland",
    stateCode: "MD",
    zip: "21044",
    lat: 39.2037,
    lng: -76.8610,
    tagline: "Termite Control in Columbia, MD",
    hook: "Serving Wilde Lake, Harper's Choice, River Hill, and Long Reach.",
    intro:
      "Columbia's planned community design means beautifully wooded lots close to every home — and shaded, damp landscaping pushes termite risk higher than open suburban plots. Many Columbia homes are now 40+ years old, past the useful life of any original builder pre-treatment. ATC retrofits full perimeter protection.",
    local: [
      "Mature wooded lots within feet of foundations",
      "Original 1970s-80s builder pre-treatments long expired",
      "Common lake and pond drainage keeps soil damp",
    ],
    nearby: ["baltimore-md", "silver-spring-md", "annapolis-md"],
  },
  {
    slug: "annapolis-md",
    city: "Annapolis",
    state: "Maryland",
    stateCode: "MD",
    zip: "21401",
    lat: 38.9784,
    lng: -76.4922,
    tagline: "Termite Control in Annapolis, MD",
    hook: "Protecting historic waterfront homes from Eastport to Murray Hill.",
    intro:
      "Annapolis's waterfront setting, high water table, and centuries-old housing stock combine to create some of the most intense termite pressure in Maryland. Salt air doesn't slow subterranean colonies — they thrive in moist, sandy soils under historic timber-framed homes. ATC handles Annapolis's unique challenges with care for original materials.",
    local: [
      "High water table across most of the peninsula",
      "Centuries-old timber framing and heart-pine floors",
      "Moist, sandy soils ideal for subterranean colonies",
    ],
    nearby: ["baltimore-md", "columbia-md", "rockville-md"],
  },
  {
    slug: "silver-spring-md",
    city: "Silver Spring",
    state: "Maryland",
    stateCode: "MD",
    zip: "20910",
    lat: 38.9907,
    lng: -77.0261,
    tagline: "Termite Control in Silver Spring, MD",
    hook: "Serving Woodside, Forest Glen, and the DC border neighborhoods.",
    intro:
      "Silver Spring's mature, tree-lined neighborhoods and older brick housing stock mean classic termite conditions. Homes built mid-century often have minimal vapor barriers, allowing soil moisture to keep sill plates perpetually damp. ATC's 360° perimeter treatment addresses Silver Spring's conditions directly.",
    local: [
      "Mature 1940s-60s brick and frame homes",
      "Minimal vapor barriers in older crawlspaces",
      "Tree-dense, shaded neighborhoods year-round",
    ],
    nearby: ["rockville-md", "columbia-md", "annapolis-md"],
  },
  {
    slug: "rockville-md",
    city: "Rockville",
    state: "Maryland",
    stateCode: "MD",
    zip: "20850",
    lat: 39.0840,
    lng: -77.1528,
    tagline: "Termite Control in Rockville, MD",
    hook: "Serving Twinbrook, King Farm, and West End neighborhoods.",
    intro:
      "Rockville spans everything from mid-century ranches in Twinbrook to new townhome developments in King Farm — each with its own termite profile. Older ranches with wood sill plates at grade and newer townhomes with shared walls both benefit from our comprehensive perimeter approach.",
    local: [
      "Mid-century ranches with sill plates close to soil",
      "Newer townhome clusters with shared foundation risk",
      "Moderate soil moisture in most Montgomery County lots",
    ],
    nearby: ["silver-spring-md", "frederick-md", "columbia-md"],
  },
  {
    slug: "glen-rock-pa",
    city: "Glen Rock",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17327",
    lat: 39.7909,
    lng: -76.7333,
    tagline: "Termite Control in Glen Rock, PA",
    hook: "Right at home — our headquarters has served Glen Rock since 1991.",
    intro:
      "Glen Rock is where ATC Pest Control was founded — we live and work in this borough. We know the older stone and brick foundations along Main Street, the wood-framed Victorians off Hanover Street, and the newer builds out toward Codorus. Heavy tree canopy and moist creek-fed soil mean termite pressure is real here. If you're in Glen Rock and call before noon, we'll usually have a tech walking your property within the week.",
    local: [
      "Historic stone foundations along the South Branch Codorus Creek",
      "Heavy mature tree canopy keeps soil cool and damp",
      "Older Victorians with original wood framing and porches",
    ],
    nearby: ["shrewsbury-pa", "new-freedom-pa", "york-pa"],
  },
  {
    slug: "shrewsbury-pa",
    city: "Shrewsbury",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17361",
    lat: 39.7665,
    lng: -76.6797,
    tagline: "Termite Control in Shrewsbury, PA",
    hook: "Serving Main Street homes and the I-83 Exit 4 corridor.",
    intro:
      "Shrewsbury's mix of historic Main Street homes and newer subdivisions off Forrest Avenue keeps us busy. The older homes along Mt. Airy Road often have stone foundations and crawlspaces where termite activity can hide for years. We treat Shrewsbury homes year-round and know the township's housing stock well.",
    local: [
      "Historic Main Street homes with stone or block foundations",
      "Newer Exit 4 subdivisions aging past their builder pre-treatments",
      "Wooded backlots common to many properties",
    ],
    nearby: ["new-freedom-pa", "glen-rock-pa", "stewartstown-pa"],
  },
  {
    slug: "new-freedom-pa",
    city: "New Freedom",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17349",
    lat: 39.7395,
    lng: -76.6802,
    tagline: "Termite Control in New Freedom, PA",
    hook: "Protecting homes along the Heritage Rail Trail and beyond.",
    intro:
      "New Freedom sits right on the Mason-Dixon line, with a tight historic core and growing neighborhoods to the north and east. Older homes along Front Street and Constitution Avenue often have wood sill plates close to grade — a classic subterranean termite entry point. We handle inspections and treatments throughout the borough.",
    local: [
      "Historic borough homes with sill plates near soil level",
      "Newer residential development to the north and east",
      "Mason-Dixon-line soil conditions favor subterranean termites",
    ],
    nearby: ["shrewsbury-pa", "stewartstown-pa", "glen-rock-pa"],
  },
  {
    slug: "stewartstown-pa",
    city: "Stewartstown",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17363",
    lat: 39.7531,
    lng: -76.5894,
    tagline: "Termite Control in Stewartstown, PA",
    hook: "Serving Hopewell Township and the historic borough.",
    intro:
      "Stewartstown's historic borough and surrounding farms make for a varied termite call list — Civil-War-era homes downtown, older farmhouses on the back roads, and newer builds going up along Route 24. Each comes with its own termite profile. We've worked Stewartstown for decades and know what to look for on every block.",
    local: [
      "Civil-War-era borough homes with original framing",
      "Working farms with outbuildings and woodpiles nearby",
      "Newer construction along the Route 24 corridor",
    ],
    nearby: ["new-freedom-pa", "shrewsbury-pa", "york-pa"],
  },
  {
    slug: "spring-grove-pa",
    city: "Spring Grove",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17362",
    lat: 39.8762,
    lng: -76.8669,
    tagline: "Termite Control in Spring Grove, PA",
    hook: "From the historic paper mill town to the rural townships around it.",
    intro:
      "Spring Grove's older mill-town housing stock often shares one feature termites love: aged wood framing in close contact with damp basements. Combine that with the heavily forested terrain west of town and you've got real subterranean pressure. ATC treats Spring Grove and surrounding North Codorus Township regularly.",
    local: [
      "Older mill-era homes with original timber framing",
      "Heavily forested terrain west of the borough",
      "Older basements with persistent moisture issues",
    ],
    nearby: ["york-pa", "hanover-pa", "dallastown-pa"],
  },
  {
    slug: "red-lion-pa",
    city: "Red Lion",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17356",
    lat: 39.9012,
    lng: -76.6058,
    tagline: "Termite Control in Red Lion, PA",
    hook: "Serving the historic cigar-factory town and Windsor Township.",
    intro:
      "Red Lion's older manufacturing-era housing — many built between 1900 and 1940 — sits on stone and block foundations that have shifted over a century. Termites exploit every gap. We treat Red Lion homes routinely and offer Wood Destroying Insect Reports (WDIR) for the constant churn of borough real estate.",
    local: [
      "Early-1900s homes on stone or block foundations",
      "Borough rowhomes with shared walls and joists",
      "Steady real-estate turnover means frequent WDIR demand",
    ],
    nearby: ["dallastown-pa", "york-pa", "stewartstown-pa"],
  },
  {
    slug: "dallastown-pa",
    city: "Dallastown",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17313",
    lat: 39.8990,
    lng: -76.6411,
    tagline: "Termite Control in Dallastown, PA",
    hook: "Protecting the borough and York Township homes around it.",
    intro:
      "Dallastown's small downtown is packed with century-old homes — beautiful, well-cared-for, and exactly the kind of construction termites target. Outside the borough, York Township ranches and split-levels from the 1960s and '70s have aging pre-treatments long past their useful life. We cover both.",
    local: [
      "Century-old downtown homes with timber framing",
      "1960s-70s York Township ranches past pre-treatment age",
      "Wooded yards close to foundations are common",
    ],
    nearby: ["red-lion-pa", "york-pa", "spring-grove-pa"],
  },
  {
    slug: "loganville-pa",
    city: "Loganville",
    state: "Pennsylvania",
    stateCode: "PA",
    zip: "17342",
    lat: 39.8540,
    lng: -76.7027,
    tagline: "Termite Control in Loganville, PA",
    hook: "Serving Springfield Township and the Susquehanna Trail corridor.",
    intro:
      "Loganville is small but spread out — historic borough homes along Main Street, working farms on the surrounding back roads, and rapid newer development along I-83. Each segment has its own termite story. ATC works Loganville routinely and our trucks are on Susquehanna Trail several days a week.",
    local: [
      "Historic borough homes with original wood framing",
      "Working farms with outbuildings and earth-to-wood contact",
      "Newer subdivisions along the I-83 corridor",
    ],
    nearby: ["glen-rock-pa", "york-pa", "dallastown-pa"],
  },
  {
    slug: "hampstead-md",
    city: "Hampstead",
    state: "Maryland",
    stateCode: "MD",
    zip: "21074",
    lat: 39.6048,
    lng: -76.8508,
    tagline: "Termite Control in Hampstead, MD",
    hook: "Serving Northern Carroll County from Main Street to Houcksville Road.",
    intro:
      "Hampstead's older borough homes and the steady new development north of town both bring termite work to our door. Carroll County's clay-heavy soils hold moisture well, and that's exactly what subterranean termite colonies need to thrive. We've treated Hampstead homes for years and know the conditions cold.",
    local: [
      "Older Main Street homes with original framing",
      "Clay-heavy Carroll County soils retain moisture",
      "Growing residential development north of the borough",
    ],
    nearby: ["manchester-md", "westminster-md", "hanover-pa"],
  },
  {
    slug: "manchester-md",
    city: "Manchester",
    state: "Maryland",
    stateCode: "MD",
    zip: "21102",
    lat: 39.6612,
    lng: -76.8847,
    tagline: "Termite Control in Manchester, MD",
    hook: "Right on the Mason-Dixon line — small town, real termite pressure.",
    intro:
      "Manchester sits on the Maryland-Pennsylvania border with a tight historic core and rural acreage all around. Older borough homes on Main Street have aged foundations; farmsteads have outbuildings, firewood, and earth-to-wood contact. Both make termite calls a regular event. ATC handles Manchester routinely.",
    local: [
      "Historic borough homes with stone foundations",
      "Outbuildings and firewood stacks near primary residences",
      "Border-area soils hold moisture similar to southern PA",
    ],
    nearby: ["hampstead-md", "westminster-md", "hanover-pa"],
  },
  {
    slug: "bel-air-md",
    city: "Bel Air",
    state: "Maryland",
    stateCode: "MD",
    zip: "21014",
    lat: 39.5359,
    lng: -76.3486,
    tagline: "Termite Control in Bel Air, MD",
    hook: "Serving the Harford County seat and surrounding neighborhoods.",
    intro:
      "Bel Air's mix of historic downtown homes, post-war ranches, and newer townhome communities creates a wide spread of termite scenarios. Older homes around Main Street have decades of foundation aging behind them. Newer subdivisions are increasingly past their builder pre-treatments. We treat throughout Harford County.",
    local: [
      "Historic downtown homes near Main Street and Bond",
      "Post-war ranches with sill plates close to grade",
      "Newer subdivisions aging out of builder pre-treatments",
    ],
    nearby: ["towson-md", "baltimore-md", "reisterstown-md"],
  },
  {
    slug: "reisterstown-md",
    city: "Reisterstown",
    state: "Maryland",
    stateCode: "MD",
    zip: "21136",
    lat: 39.4690,
    lng: -76.8275,
    tagline: "Termite Control in Reisterstown, MD",
    hook: "Serving the historic village and Owings Mills border neighborhoods.",
    intro:
      "Reisterstown's historic core sits on some of Baltimore County's oldest foundations — many predate 1900. Newer suburban growth toward Owings Mills has its own challenges as those builds reach 30-40 years old. ATC treats Reisterstown and the surrounding Baltimore County area regularly.",
    local: [
      "Pre-1900 historic homes with original timber framing",
      "Mature trees and shaded landscaping throughout the area",
      "Aging post-1980s subdivisions toward Owings Mills",
    ],
    nearby: ["towson-md", "baltimore-md", "westminster-md"],
  },
];

export const findCity = (slug) => CITIES.find((c) => c.slug === slug);
